import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import './index.css';
import { useState } from 'react';

function HomeMenu({ show, onClose }) {
  const [openBox, setOpenBox] = useState(null);
  const toggleBox = (boxName) => {
    setOpenBox(openBox === boxName ? null : boxName);
  };

  return (
    <div className={`overlay ${show ? 'show' : ''}`}>
      <div className='overlay-header'>
        <div className="overlay-header-menu text-2xl">
          <span>MENU</span>
          <button onClick={onClose}>
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </div>

      <div className='overlay-content'>

      <div className='overlay-content-box'>
          <h3 className='title' onClick={() => toggleBox('constituicoes')}>CONSTITUIÇÕES</h3>
          <div className={`submenu ${openBox === 'constituicoes' ? 'active' : ''}`}>
            <Link to='/constituicoes' className='box-text'>Constituições Brasileiras</Link>
            <Link to='/constituicoes/1824' className='box-text'>1824</Link>
            <div className="subunits">
              <Link to='/constituicoes/1824/1' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>I</Link>
              <Link to='/constituicoes/1824/2' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>II</Link>
              <Link to='/constituicoes/1824/3' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>III</Link>
              <Link to='/constituicoes/1824/4' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>IV</Link>
              <Link to='/constituicoes/1824/5' className='p-1 text-[18px] text-inherit no-underline hover:text-black transition-colors duration-300'>V</Link>
            </div>
            <Link to='/constituicoes/1891' className='box-text'>1891</Link>
            <Link to='/constituicoes/1934' className='box-text'>1934</Link>
            <Link to='/constituicoes/1937' className='box-text'>1937</Link>
            <Link to='/constituicoes/1946' className='box-text'>1946</Link>
            <Link to='/constituicoes/1967' className='box-text'>1967</Link>
            <Link to='/constituicoes/1988' className='box-text'>1988</Link>
          </div>
        </div>

        <div className='overlay-content-box'>
          <h3 className='title' onClick={() => toggleBox('congresso')}>O PALÁCIO DO CONGRESSO NACIONAL</h3>
          <div className={`submenu ${openBox === 'congresso' ? 'active' : ''}`}>
            <Link to='/sedeSenado' className='box-text'>Senado Federal</Link>
            <Link to='/parlamentoNovaCapital' className='box-text'>O Parlamento e a nova Capital</Link>
            <Link to='/ConstrucaoInstalacao' className='box-text'>Construção e Instalação</Link>
            <Link to='/Inauguracao' className='box-text'>Inauguração do Congresso Nacional</Link>
          </div>
        </div>
        
        <div className='overlay-content-box'>
          <h3 className='title' onClick={() => toggleBox('origens')}>POSSES PRESIDENCIAIS</h3>
          <div className={`submenu ${openBox === 'origens' ? 'active' : ''}`}>
            <Link to='/ditadura' className='box-text'>Da Democracia à Ditadura 1946 - 1964</Link>
            <Link to='/militar' className='box-text'>Ditadura Militar 1964 - 1984</Link>
            
            {/* <Link to='/PalacioCondeArcos' className='box-text'>Palácio Conde dos Arcos</Link>
            <Link to='/PalacioMonroe' className='box-text'>Palácio Monroe</Link>*/}
          </div>
        </div>

        

        

        <div className='overlay-content-box'>
          <h3 className='title' onClick={() => toggleBox('eixos')}>EIXOS TEMÁTICOS</h3>
          <div className={`submenu ${openBox === 'eixos' ? 'active' : ''}`}>
            <Link to='/legislativo' className='box-text'>Poder Legislativo</Link>
            <Link to='/rel' className='box-text'>Relações internacionais</Link>
            <Link to='/terra-e-poder' className='box-text'>Terra e poder</Link>
            <Link to='/ambiental' className='box-text'>Meio ambiente</Link>
            <div className="subunits">
              <Link to='/ambiental' className='box-text'>I</Link>
              <Link to='/ambiental/2' className='box-text'>II</Link>
            </div>
            <Link to='/religiao' className='box-text'>Religião</Link>
            <div className="subunits">
              <Link to='/religiao' className='box-text'>I</Link>
              <Link to='/religiao2' className='box-text'>II</Link>
            </div>
            <Link to='/direitos' className='box-text'>Direitos Humanos</Link>
            <Link to='/cultura' className='box-text'>Cultura e Patrimônio</Link>
            <div className="subunits">
              <Link to='/cultura' className='box-text'>I</Link>
              <Link to='/cultura2' className='box-text'>II</Link>
            </div>
            <Link to='/OrigemEvolucaoForma' className='box-text'>O Parlamento: Origem, evolução e forma</Link>            
            <Link to='/parlamento' className='box-text'>O Parlamento Brasileiro e as Forças Militares</Link>
          </div>
        </div>

        <div className='overlay-content-box'>
          <h3 className='title' onClick={() => toggleBox('documentarios')}>DOCUMENTÁRIOS</h3>
          <div className={`submenu ${openBox === 'documentarios' ? 'active' : ''}`}>
            <Link to='/documentarios' className='box-text'>Todos</Link>
            <Link to='/episodios/1' className='box-text'>Bernardo Cabral</Link>
            <Link to='/episodios/2' className='box-text'>Jarbas Passarinho</Link>
            <Link to='/episodios/3' className='box-text'>Marco Maciel</Link>
            <Link to='/episodios/4' className='box-text'>José Genoíno</Link>
            <Link to='/episodios/5' className='box-text'>O Golpe de 1964 e o Parlamento</Link>
            <Link to='/episodios/6' className='box-text'>A Redemocratização</Link>
            <Link to='/episodios/7' className='box-text'>A Constituição de 1888</Link>
            {/*<Link to='/episodios/8' className='box-text'>A Constituição de 1824 e os escravizados</Link>*/}
            <Link to='/episodios/8' className='box-text'>Yanomami</Link>
            {/*<Link to='/episodios/10' className='box-text'>8 de janeiro</Link>*/}
          </div>
        </div>

      </div>
    </div>
  );
}

export default HomeMenu;